// R41 fail-loud env wrapper (sub-plan 13 §13.2). Reads `import.meta.env.VITE_X`
// and throws synchronously on first import if any required key is missing or
// empty. Without this wrapper, Vite emits `undefined` (not the string) when an
// env var is unset; the resulting `createClient(undefined, undefined, ...)`
// AND `<CaptchaWidget siteKey={undefined}>` both render broken UI silently.
//
// All admin web consumers MUST import { ENV } from "@/lib/env" rather than
// reaching directly into import.meta.env.VITE_X.

function need(k: string, v: string | undefined): string {
  if (v === undefined || v === null || v === "") {
    throw new Error(
      `Missing required env var: VITE_${k} (set it in apps/admin/.env per sub-plan 01 §1.3)`,
    );
  }
  return v;
}

export const ENV = {
  SUPABASE_URL: need("SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  SUPABASE_PUBLISHABLE_KEY: need(
    "SUPABASE_PUBLISHABLE_KEY",
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  ),
  API_BASE_URL: need("API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
  TURNSTILE_SITE_KEY: need(
    "TURNSTILE_SITE_KEY",
    import.meta.env.VITE_TURNSTILE_SITE_KEY,
  ),
} as const;
